import React, { Component } from 'react';
import Link from 'gatsby-link';
import { withRouter } from 'react-router-dom';
import checkRedirect from '../components/redirect';

class steps extends Component {
    constructor(props) {

        super(props);
    }
    
    componentDidMount(){
        checkRedirect(this.props);
    }

    render() {

        // active class trick for  "/" and "/funnel"
        let HomePath = "/funnel";
        if(this.props.history.location.pathname == "/result"){
            return null;
        }

        
        if(this.props.history.location.pathname == "/"){
            HomePath = "/";
        }
        
        // steps structure
        return (
            <div className="steps">
                <div className="container">
                    <ul className="MainMenu">
                        <li> <Link exact to={HomePath} activeClassName="active" data-enable={this.props.siteProps.funnel} > Funnel</Link></li>
                        <li><Link to="revenue-ltv" activeClassName="active" data-enable={this.props.siteProps.funnel && this.props.siteProps['revenue-ltv']}  > Revenue & LTV</Link></li>
                        <li><Link to="investment" activeClassName="active" data-enable={this.props.siteProps.funnel && this.props.siteProps['revenue-ltv'] && this.props.siteProps.investment}  > Investment</Link></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default withRouter(steps);


// WEBPACK FOOTER //
// ./src/components/steps.js